module.exports = __webpack_public_path__ + "static/media/bells_2.1eb0a225.jpg";